module.exports = __webpack_public_path__ + "static/media/silkycloud-1.26b7002d.png";